import { EditorView } from 'prosemirror-view'
import { EDITOR_CONTAINER_ID } from 'screens/ProseEdit/Constants'

export const getFakeSelectionRect = (view: EditorView) => {
  const domFrom = view.domAtPos(view.state.selection.from)
  const domTo = view.domAtPos(view.state.selection.to)
  const range = document.createRange()
  range.setStart(domFrom.node, domFrom.offset)
  range.setEnd(domTo.node, domTo.offset)
  return range.getBoundingClientRect()
}

export const getBrowserSelectionRect = () => {
  const isSupported = typeof window.getSelection !== 'undefined'
  if (!isSupported) {
    return
  }

  const selection = window.getSelection()
  const editorMainContent = document.getElementById(EDITOR_CONTAINER_ID)
  if (!editorMainContent || !selection || selection.rangeCount === 0) {
    return
  }

  const range = selection.getRangeAt(0)
  if (!editorMainContent.contains(range.startContainer)) {
    return
  }

  return range.getBoundingClientRect()
}
